import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import AccountClosingPopup from 'components/popups/AccountClosingPopup';

import { useAlertPopup } from './useAlertPopup';
import { usePopup } from './usePopup';

export const useAccountClosingPopup = () => {
  const { t } = useTranslation('myProfile');
  const { showPopup, hidePopup } = usePopup();
  const navigate = useNavigate();
  const { showAlertPopup } = useAlertPopup();

  const contactSupport = () => {
    showAlertPopup({
      header: t('account-settings.contact-support'),
      description: t('account-settings.contact-support-desc'),
      firstButton: {
        label: t('account-settings.go'),
        onClick: () => navigate('/messenger/support'),
      },
      secondButton: { label: t('account-settings.cancel') },
    });
  };
  const showAccountClosingPopup = () =>
    showPopup(
      <AccountClosingPopup
        onFirstButtonClick={() => {
          hidePopup();
          contactSupport();
        }}
        onSecondButtonClick={() => hidePopup()}
      />
    );

  return { showAccountClosingPopup };
};
